<script lang="ts">
    export let id: string;
    export let percentage: number = 50;
    export let min: number = 10;
    export let max: number = 90;
    if (localStorage.getItem(`divider${id}`)) {
        percentage = parseInt(localStorage.getItem(`divider${id}`), 10);
    }
    let container: HTMLElement;
    function divider(node: HTMLElement) {
        function onMouseMove(e: MouseEvent) {
            const rect = container.getBoundingClientRect();
            let moved = e.pageX - rect.left;
            let shadowPercentage = (moved / rect.width) * 100;
            if (shadowPercentage < min) {
                shadowPercentage = min;
            } else if (shadowPercentage > max) {
                shadowPercentage = max;
            }
            percentage = shadowPercentage;
        }

        function onMouseUp(e: MouseEvent) {
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
            localStorage.setItem(`divider${id}`, percentage.toString());
        }

        node.addEventListener("mousedown", (e) => {
            e.preventDefault();
            e.stopPropagation();
            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
        });
    }
</script>

<div class="DividedView" bind:this={container}>
    <div
        class="Window1"
        style="min-width: {percentage}%; max-width: {percentage}%;"
    >
        <slot name="window1" />
    </div>
    <div class="DividerSlider" use:divider />
    <div class="Window2">
        <slot name="window2" />
    </div>
</div>

<style type="text/scss">
    @import "../scss/config.scss";
    .DividedView {
        display: flex;
        flex-grow: 1;
    }
    .DividerSlider {
        width: 8px;
        background: $color-light-grey;
        flex-shrink: 0;
        cursor: w-resize;
    }
    .Window2 {
        flex-grow: 1;
    }
</style>
